import { type } from "arktype";

const envSchema = type({
  LOGO_DEV_TOKEN: "string='pk_VmwCVpT_QZSo-pgrYf3S6Q'",
  // SENTRY_AUTH_TOKEN: "string",
  VITE_CLIENT_BASE_URL: "string='http://localhost:5173'",
  VITE_ENVIRONMENT: "('development' | 'staging' | 'production')='development'",
  VITE_POSTHOG_PUBLIC_KEY: "string",
  VITE_SERVER_BASE_URL: "string='http://localhost:3000'",
});
export const env = envSchema.assert(import.meta.env);
